<template>
  <el-table-column
      v-for="(column, idx) in tblColumns" :key="idx"
      :prop="column.prop"
      :label="column.label"
      :width="column.width ? column.width : null"
      :min-width="column.minWidth ? column.minWidth : null"
      :align="column.align ? column.align : 'center'"
      :show-overflow-tooltip="column.tooltip === 'off' ? false : true">
      <!-- 自定义表头 -->
    <template #header="scope" v-if="column.headerSlot">
      <slot :name="column.headerSlot" :row="scope.row"></slot>
    </template>
    <template #default="scope">
      <div v-if="!column.slot">
        <div v-if="!isEmpty(scope.row[column.prop])">
          <!-- MAPPING -->
          <div v-if="column.type === RSP_ITEM_TYPE.MAPPING">
            <div v-if="column.category && dict[column.category] && dict[column.category].mappings && scope.row[column.prop]">
              {{dict[column.category].mappings[scope.row[column.prop]]}}
            </div>
            <div v-else>-</div>
          </div>
          <!-- MAPPING - EXTRA -->
          <div v-else-if="column.type === RSP_ITEM_TYPE.MAPPING_EXTRA">
            <div v-if="column.category && dict[column.category] && dict[column.category].mappings && scope.row[column.prop]">
              <sr-status :category="column.category" :code="scope.row[column.prop]" :with-background="false"></sr-status>
            </div>
            <div v-else>-</div>
          </div>
          <!-- MAPPING - TAG -->
          <div v-else-if="column.type === RSP_ITEM_TYPE.MAPPING_TAG">
            <div v-if="column.category && dict[column.category] && dict[column.category].mappings && scope.row[column.prop] && (dict[column.category].mappings[scope.row[column.prop]] || dict[column.category].mappings[Number(scope.row[column.prop])])">
              <el-tag :type="(dict[column.category].mappings[scope.row[column.prop]] || dict[column.category].mappings[Number(scope.row[column.prop])]).tagType">
                {{(dict[column.category].mappings[scope.row[column.prop]] || dict[column.category].mappings[Number(scope.row[column.prop])]).label}}
              </el-tag>
            </div>
            <div v-else>-</div>
          </div>
          <!-- AMOUNT -->
          <div v-else-if="column.type === RSP_ITEM_TYPE.AMOUNT">
            {{$filters.currency(scope.row[column.prop], (column.depend && scope.row[column.depend]) ? scope.row[column.depend] : '', '', 'amount')}}

            <div v-if="column.depend">{{scope.row[column.depend]}}</div>
          </div>
          <!-- RATE -->
          <div v-else-if="column.type === RSP_ITEM_TYPE.RATE">
            {{$filters.currency(scope.row[column.prop], (column.depend && scope.row[column.depend]) ? scope.row[column.depend] : '', '', 'rate')}}
          </div>
          <!-- DATE -->
          <div v-else-if="column.type === RSP_ITEM_TYPE.DATE">
            {{$filters.date(scope.row[column.prop], column.category)}}
          </div>
          <!-- DEFAULT -->
          <div v-else>{{scope.row[column.prop]}}</div>
        </div>
        <!-- NULL DEFAULT -->
        <div v-else>
          <div>-</div>
        </div>
      </div>
      <div v-else>
        <slot :name="column.slot" :row="scope.row"></slot>
      </div>
    </template>
  </el-table-column>
</template>

<script>
import { reactive, toRefs } from 'vue'
import common from '@/compositions/modules/common'
import { commonUtils } from '@libs/utils'
import SrStatus from '../SrStatus/index'

export default {
  name: 'sr-table-column',
  components: {
    SrStatus
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const { dict, constant: { RSP_ITEM_TYPE } } = common()

    const scopedComp = {
      dict,
      RSP_ITEM_TYPE,
      isEmpty: commonUtils.isEmpty
    }

    const state = reactive({
      tblColumns: props.columns.filter(item => {
        return item.visible === undefined || item.visible
      })
    })

    return {
      ...scopedComp,
      ...toRefs(state)
    }
  }
}
</script>

<style scoped>

</style>
